const zIndex = {
  menu: 100,
};

export { zIndex };
